import '@mantine/core/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/notifications/styles.css';

import { ApolloProvider } from '@apollo/client/react';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router';

import { apolloClient } from './apollo/client';
import { App } from './App';
import { AuthProvider } from './auth/AuthProvider';
import i18n from './i18n';
import { theme } from './theme';

const container = document.getElementById('root');

if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    {/* `defaultColorScheme="auto"` follows the system until the toggle in the
        header writes a choice, which Mantine then keeps in localStorage. */}
    <MantineProvider theme={theme} defaultColorScheme="auto">
      <I18nextProvider i18n={i18n}>
        <Notifications position="top-right" />
        <ApolloProvider client={apolloClient}>
          <BrowserRouter>
            {/* Inside the router: the provider navigates on sign-out and on an
                expired session. */}
            <AuthProvider>
              <ModalsProvider>
                <App />
              </ModalsProvider>
            </AuthProvider>
          </BrowserRouter>
        </ApolloProvider>
      </I18nextProvider>
    </MantineProvider>
  </StrictMode>,
);
